import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ProgressBar from '../../../ProgressBar';
import LoadingIndicator from '../../../LoadingIndicator';
import s from './UploadThumb.scss';
var UploadThumb = /** @class */ (function (_super) {
    __extends(UploadThumb, _super);
    function UploadThumb() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.preview = React.createRef();
        return _this;
    }
    UploadThumb.prototype.componentDidMount = function () {
        var _this = this;
        // set the preview of the file currently being uploaded
        var reader = new FileReader();
        reader.onload = function (e) {
            if (_this.preview.current && e.target) {
                _this.preview.current.src = e.target.result; // TS3 dom lib is a bit dumb for now
            }
        };
        reader.readAsDataURL(this.props.file);
    };
    UploadThumb.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.progress, progress = _b === void 0 ? 0 : _b, error = _a.error;
        return (React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement("img", { className: s['preview'], alt: "Upload Preview", ref: this.preview }),
            error && React.createElement("div", { className: s['error'] }, error),
            !error && progress >= 1 && (React.createElement(LoadingIndicator, { className: s['please-wait'] })),
            !error && (React.createElement(ProgressBar, { className: classnames(s['progress'], progress >= 1 && s['progress-done']), barClassName: s['bar'], background: "none", percentage: progress * 100 }))));
    };
    return UploadThumb;
}(React.Component));
export default UploadThumb;
//# sourceMappingURL=UploadThumb.js.map